import React from "react";
import ContentHeading from "@/components/content-heading";
import {container, headingContainer, subheading} from "@/components/free-resources/styles/free-resources-hero";
import {useTranslation} from "react-i18next";

const FreeResourcesHero: React.FC = () => {
    const {t} = useTranslation()
    return (
        <div className={container} title={t("free-resources.header.seo.title")} aria-label={t("free-resources.header.seo.aria-label")}>
            <div className={headingContainer}>
                <ContentHeading
                    h="p"
                    className="justify-center"
                    backdropPosition="mobile:left-4 tablet:left-8"
                    fontSize="mobile:text-3xl tablet:text-5xl"
                    background={"bg-primary/60"}
                >
                    {t("free-resources.header.heading")}
                </ContentHeading>
                <p className={subheading}>{t("free-resources.subheading")}</p>
            </div>
        </div>
    )
}

export default FreeResourcesHero
